import { Component, AfterViewInit } from '@angular/core';
import { SwiperService } from '../../services/swiper.service';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.css']
})
export class TestimonialsComponent implements AfterViewInit {
  testimonials = [
    {
      text: "Veedu Plan transformed our dream home concept into reality! Their attention to detail in the floor plan and design was exceptional. Highly recommend their professional team.",
      name: "Priya Kumar",
      role: "Home Buyer",
      image: "https://cdn-icons-png.flaticon.com/512/847/847969.png"
    },
    {
      text: "I was amazed at how quickly Veedu Plan understood our requirements and provided innovative layouts. The designs were practical, modern, and beautiful.",
      name: "Sandeep Raj",
      role: "Manager",
      image: "https://cdn-icons-png.flaticon.com/512/847/847969.png"
    },
    {
      text: "Professional, creative, and reliable! Veedu Plan exceeded our expectations with innovative solutions for our floor plan. Our dream home is now coming to life!",
      name: "Anitha R",
      role: "Architect",
      image: "https://cdn-icons-png.flaticon.com/512/847/847969.png"
    },
    {
      text: "Our new home plan perfectly matches our lifestyle. The architects at Veedu Plan considered every little detail, making the house functional and aesthetically pleasing.",
      name: "Dinesh M",
      role: "Student",
      image: "https://cdn-icons-png.flaticon.com/512/847/847969.png"
    }
  ];

  constructor(private swiperService: SwiperService) {}

  ngAfterViewInit(): void {
    // Re-initialize swipers when component is loaded
    setTimeout(() => {
      this.swiperService.initMarqueeSwipers();
    }, 100);
  }
}

